<tec-item
	[tagImage]="{ icon: documentIcon, status: 'control' }"
	[title]="titleKey | translate"
	[clickeable]="false"
>
	@if (doc?.state) {
		<tec-tag
			[label]="('MASTER.STATUS.' + doc.state) | translate"
			[status]="masterService.getTagStatusDoc(doc.state)"
		/>
	}

	<tec-tag
		[label]="('PROCESSES.DETAIL.' + (doc?.mode === 'auto' ? 'AUTOMATIC' : 'MANUAL')) | translate"
	/>

	<tec-list-detail>
		<tec-info-group>
			<b>{{ 'PROCESSES.DETAIL.NUM_TRIED' | translate }}</b>
			<tec-badge
				[label]="doc?.total_tries?.toString() ?? ('GENERAL.NOT_AVAILABLE' | translate)"
				type="square"
			/>
			@if (doc?.state === DocStatus.KO) {
				<tec-tag-icon size="sm" [icon]="'icon-alert'" />
			}
		</tec-info-group>
	</tec-list-detail>

	<tec-button-icon icon="icon-eye" (click)="onOpen()" />
</tec-item>
